import { BASE_URL } from '../ApiService/ApiConfig.js';
import axios from 'axios';

export class ViajesService {
    obtenerConfig() {
        let token = localStorage.getItem('jwt');
        if (token) {
            token = token.replaceAll('"', '');
        }

        return {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
                'Authorization': 'Bearer ' + token
            }
        };
    }

    async obtenerViajesActivos() {
        try {
            const config = this.obtenerConfig();
            const response = await axios.get(

                `${BASE_URL}/viaje/opemv1_v2/viajes`,
                config
            );

            console.log('Respuesta de obtenerViajesActivos:', response.data);

            return response.data;
        } catch (error) {
            console.error('Error al obtener viajes activos:', error);
            return [];
        }
    }


    async obtenerUbicacionesActivas() {
        try {
            const config = this.obtenerConfig();
            const response = await axios.get(

                `${BASE_URL}/ubicacion/estado/Activo`,
                config
            );
            return response.data;
        } catch (error) {
            console.error('Error al obtener ubicaciones activas:', error);
            return [];
        }
    }

    async obtenerTarjetasPorUbicacion(ubicacionId) {
        try {
            const config = this.obtenerConfig();
            const response = await axios.get(

                `${BASE_URL}/ubicacion/${ubicacionId}/estado/Activo`,
                config
            );

            const tarjetas = response.data.data?.ubicacionTarjetaList || [];

            return tarjetas.map(item => ({
                id: item.tarjeta?.tarjetaId,
                titulo: item.tarjeta?.identificador // Aquí se extrae lo que se mostrará
            }));
        } catch (error) {
            console.error(`Error al obtener tarjetas de la ubicación ${ubicacionId}:`, error);
            return [];
        }
    }

    async enviarComando(payload) {
        try {
            const config = this.obtenerConfig();
            const response = await axios.post(

                `${BASE_URL}/comando/procesar`,
                payload,
                config
            );
            return response.data;
        } catch (error) {
            console.error('Error al enviar el comando:', error);
            throw error;
        }
    }

    async obtenerCodigoAutorizacionResponsable() {
        try {
            const config = this.obtenerConfig();
            const response = await axios.get(

                `${BASE_URL}/usuario/dole/codigo_autorizacion_responsable`,
                config
            );
            return response.data;
        } catch (error) {
            console.error('Error al obtener el código de autorización responsable:', error);
            return null;
        }
    }

    async solicitarToken(payload) {
    try {
        const config = this.obtenerConfig();
        const response = await axios.post(

            `${BASE_URL}/comando/procesar/codigo_autorizacion`,
            payload,
            config
        );
        return response.data;
    } catch (error) {
        console.error('Error al enviar el código de autorización:', error);
        throw error;
    }
}


}
